import { Checkbox, css, styled } from "@mui/material";

export const ObjectTreeCheckbox = styled(Checkbox)(
    () => css`
        padding: 4px;
    `,
);
